exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 768px) {\n.portlet_wrapper[data-v-02176e68] {\n    padding: 20px;\n}\n.view_type_select[data-v-02176e68] {\n    margin-bottom: 30px;\n}\n.cnt_block[data-v-02176e68] {\n    padding: 0;\n}\n}", ""]);

// exports
